// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__7ITfY","heading":"style_heading__Ag4V6","tips_container":"style_tips_container__3P-qf","tips":"style_tips__1qw8X"};